import { Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

declare var $: any;

@Component({
  selector: 'lib-inactivity-check-modal',
  templateUrl: './inactivity-check-modal.component.html',
  styleUrls: ['./inactivity-check-modal.component.scss']
})
export class InactivityCheckModalComponent {

  @ViewChild('inactivityCheckModal') modalRef = {} as ElementRef;
  @Input() countdown: number = 0;
  @Output() continueEditingEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() returnOverviewEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  continueEditing() {
    this.continueEditingEmit.emit(true);
  }

  returnToOverview() {
    this.returnOverviewEmit.emit(true);
  }

  showModal() {
    const modalElement = $(this.modalRef.nativeElement);
    modalElement.modal({
      backdrop: 'static',
      keyboard: false
    });

    modalElement.modal('show');
  }

  closeModal() {
    const modalElement = $(this.modalRef.nativeElement);
    modalElement.modal('hide');
  }
}
